module.exports = __webpack_public_path__ + "static/media/HTA-Experts.f3bc32fd.jpg";